import React, { Component, Fragment } from 'react';
import * as ReactRedux from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { compose, pick, find } from 'ramda';
import format from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay'
import CloseIcon from '@material-ui/icons/Close';
import ExpansionPanel from '../../components/ExpantionPanel/ExpantionPanel';
import ExpansionPanelSummary from '../../components/ExpantionPanel/ExpantionPanelSummary';
import ExpansionPanelDetails from '../../components/ExpantionPanel/ExpantionPanelDetails';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import Drawer from '@material-ui/core/Drawer';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import CircularProgress from '@material-ui/core/CircularProgress';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import * as Constants from '../../actions';
import { getFormattedTimes } from '../../lib/date-utils';
import Pagination from '../../components/Pagination';
import Loader from '../../components/loader';
import styles from './styles';
import preProcessTeeTime from '../../lib/preProccessTeeTime';
import { CALENDAR, ChevronDown, ChevronLeft, ChevronRight, GolfCarate, Filter } from '../../components/Icons';
import DatePicker from '../../components/DatePicker'
import TeeSheet from '../../components/TeeSheet';
import AdvancedFilters from '../../components/AdvancedFilters';
import AdvancedFiltersMobile from '../../components/AdvancedFiltersMobile';
import GolferQtyExpantionPanel from '../../components/GolferQtyExpantionPanel';
import QuantitySelector from '../../components/QuantitySelector';
import Logo from '../../images/Powered_by_GN.png';
// import FilterIcon from '../../images/icon_options.png' ;

const Transition = props => <Slide direction = "up" { ...props}/>

class TeeTimeSearch extends Component {

    state = {
        showCalander: false,
        drawer: false,
        drawerComponent: null,
        mobileQty: 0,
        showMobileQtyLoader: false,
        drawerState: {
            qty: 0,
            selectedDate: null,
            filters: pick(['golfCartSelection', 'holeCountSelection', 'priceRange', 'timeRange'], this.props)
        }
    }

    handleCalanderPanelChange = (event, expanded) => this.setState({
        showCalander: expanded
    })
    handleTeetimeSelection = id => {
        const isMobile = isWidthDown('xs', this.props.width, true)
        this.props.dispatch({
            type: Constants.TEETIME_SELECTED,
            payload: id,
            // case for when mobile and golferQty is not selected
            isMobileModal: isMobile && !this.props.selectedGolferQty,
        })
        // only call if a qty has been selected
        if(this.props.selectedGolferQty){
            this.handleTeeTimeBook()
        }
        // If desktop view
        else if (!isMobile){
            this.props.dispatch({ type: Constants.SCROLL_TO_TOP })
        }
    }
    handleCloseGolferQtyModal = () => this.props.dispatch({
        type: Constants.CANCEL_SELECTED_TEETIME
    })

    handleGolferQtySelectMobile = value => {
        this.setState({
            mobileQty: value,
            showMobileQtyLoader: true
        });
        this.props.dispatch({
            type: Constants.TEETIME_GOLFERCOUNT_SELECTED,
            payload: value,
            // hideModal: true
        })
        this.handleTeeTimeBook()
    }

    handleTeeTimeBook = event => this.props.dispatch({
        type: Constants.CREATE_RESERVATION
    })

    handleDateChange = date => {
        this.props.dispatch({
            type: Constants.CALANDER_UPDATE,
            payload: date
        })
        this.setState({ showCalander: false })
    }

    handleDateChangeDrawer = date => {
        this.setState({
            drawerState: { ...this.state.drawerState, selectedDate: date }
       })
       this.toggleDrawer(null, false)();
       this.handleDateChange(date);
    }

    handlePageSelection = page => this.props.dispatch({
        type: Constants.PAGE_UPDATE,
        payload: {
            currentPage: page
        }
    })

    handleTimeChange = value => {
        const formattedTimes = getFormattedTimes(value[0], value[1]);
        const payload = {
            maxSelected: parseInt(value[1], 10),
            maxSelectedFormatted: formattedTimes[1],
            minSelected: parseInt(value[0], 10),
            minSelectedFormatted: formattedTimes[0]
        }
        this.props.dispatch({ type: Constants.TIMERANGE_UPDATE, payload })
    }

    handleTimeChangeDrawer = value => {
        const formattedTimes = getFormattedTimes(value[0], value[1]);
        const payload = {
            maxSelected: parseInt(value[1], 10),
            maxSelectedFormatted: formattedTimes[1],
            minSelected: parseInt(value[0], 10),
            minSelectedFormatted: formattedTimes[0]
        }
        this.setState({
            drawerState: {
                ...this.state.drawerState,
                filters: {
                    ...this.state.drawerState.filters,
                    timeRange:  { ...this.state.drawerState.filters.timeRange, ...payload }
                }
            }
        })
    }


    handlePriceRangeInputChange = value => {
        const maxSelected = parseInt(value[1], 10)
        const minSelected =  parseInt(value[0], 10)
        const payload = {
            maxSelected: maxSelected,
            minSelected: minSelected,
            minTextInput: value[0],
            maxTextInput: value[1]
        }
        this.props.dispatch({ type: Constants.PRICERANGE_UPDATE, payload })
    }

    handlePriceRangeInputChangeDrawer = value => {
        const maxSelected = parseInt(value[1], 10)
        const minSelected =  parseInt(value[0], 10)
        const payload = {
            maxSelected: maxSelected,
            minSelected: minSelected,
            minTextInput: value[0],
            maxTextInput: value[1]
        }
        this.setState({
            drawerState: {
                ...this.state.drawerState,
                filters: {
                    ...this.state.drawerState.filters,
                    priceRange: { ...this.state.drawerState.filters.priceRange, ...payload }
                }
            }
        })
    }

    handlePriceTextInputChange = (inputName, event) => {
        const value = event.target.value;
        const isMin = inputName === 'min';
        const min = isMin ? parseInt(value, 10) : this.props.priceRange.minSelected;
        const max = !isMin ? parseInt(value, 10) : this.props.priceRange.maxSelected;
        const payload = {
            maxSelected: isMin ? max : isNaN(max) ? this.props.priceRange.maxSelected : max,
            minSelected: !isMin ? min : isNaN(min) ? this.props.priceRange.minSelected : min,
            minTextInput: !isMin ? this.props.priceRange.minTextInput : isNaN(min) ? '' : min,
            maxTextInput: isMin ? this.props.priceRange.maxTextInput : isNaN(max) ? '' : max
        }
         this.props.dispatch({ type: Constants.PRICERANGE_UPDATE, payload })
    }

    handleApplyDrawerFilters = () => {
        const { priceRange, timeRange, golfCartSelection, holeCountSelection } = this.state.drawerState.filters
        this.toggleDrawer(null, false)();
        this.props.dispatch({ type: Constants.PRICERANGE_UPDATE, payload: priceRange })
        this.props.dispatch({ type: Constants.TIMERANGE_UPDATE, payload: timeRange })
        this.props.dispatch({ type: Constants.HOLECOUNT_UPDATE, payload: holeCountSelection })
        this.props.dispatch({ type: Constants.GOLFCART_UPDATE, payload: golfCartSelection })
    }
    handleHoleSelection = event => this.props.dispatch({
        type: Constants.HOLECOUNT_UPDATE,
        payload: event.target.value
    })

    handleHoleSelectionDrawer = event => this.setState({
        drawerState: {
            ...this.state.drawerState,
            filters: {
                ...this.state.drawerState.filters,
                holeCountSelection: event.target.value
            }
        }
    })

    handleCartSelection = event => this.props.dispatch({
        type: Constants.GOLFCART_UPDATE,
        payload: event.target.value
    })

    handleCartSelectionDrawer = event => this.setState({
        drawerState: {
            ...this.state.drawerState,
            filters: {
                ...this.state.drawerState.filters,
                golfCartSelection: event.target.value
            }
        }
    })

    handleGolferCountChange = value => this.props.dispatch({
        type: Constants.GOLFERCOUNT_UPDATE,
        payload: value
    })

    handleGolferCountChangeDrawer = value => {
        this.setState({
            drawerState: { ...this.state.drawerState, qty: value }
        })
        this.toggleDrawer(null, false)();
        this.handleGolferCountChange(value);
    }

    handleFilterReset = () => this.props.dispatch({
        type: Constants.RESET_FILTERS
    })

    handleFilterApplied = () => this.props.dispatch({
        type: Constants.RELEASE_FILTER_SNAPSHOT
    })

    handleFilterOpened = () => this.props.dispatch({
        type: Constants.TAKE_FILTER_SNAPSHOT
    })

    loadMoreTimesMobile = () => this.props.dispatch({
        type: Constants.MOBILE_LOAD_MORE
    })

    toggleDrawer = (drawerComponent, open) => () => {
        // DISPATCH THAT THE DRAWER IS TOGGLED SO THAT WE CAN HIDE TEETIMES TO REDUCE PAGE SIZE
        // SO THE DRAWER IS VISIBLE IN THE IFRAME
        if(open){
            this.props.dispatch({ type: Constants.DRAWER_OPENED })
        }
        else {
            this.props.dispatch({ type: Constants.DRAWER_CLOSED })
        }
        if(open){
            switch (drawerComponent) {
                case 'QTY': {
                    this.setState({ drawerState: { ...this.state.drawerState, qty: this.props.golferCount }})
                    break;
                }
                case 'CAL': {
                    this.setState({ drawerState: { ...this.state.drawerState, selectedDate: this.props.selectedDate }})
                    break;
                }
                default: {
                    this.setState({
                        drawerState: {
                            ...this.state.drawerState,
                            filters: pick(['golfCartSelection', 'holeCountSelection', 'priceRange', 'timeRange'], this.props)
                        }
                    })
                    break;
                }
            }
        }

        if(drawerComponent){
            this.setState({
                drawer: open,
                drawerComponent
            });
        }
        else {
            this.setState({
                drawer: open
              });
        }
      };

      resetDrawerFilter = () => {
        this.handleFilterReset();
        this.toggleDrawer(null, false)();
      }

    render() {
        const { classes, theme, teetimes: _teetimes, selectedDate, golferCount, selectedTeeTime: _selctedTeeTime, fetchingReservation, teetimeUnavailibleError } = this.props;
        const advFilters = pick(['golfCartSelection', 'holeCountSelection', 'priceRange', 'timeRange'], this.props);
        const {
            currentPage,
            numberOfPages,
            pageSize,
            teeTimes,
            visibleTimes,
            hotDeals,
            isFetching,
            mobileVisibleTimes
        } = _teetimes;
        const paginationProps = {
            currentPage: currentPage,
            numberOfPages: numberOfPages,
            pageSize,
            resultCount: teeTimes.length,
            onClick: this.handlePageSelection
        }
        const {
            qty : drawerQty,
            selectedDate: drawerSelectedDate,
            filters: drawerAdvFilters
        } = this.state.drawerState
        const {
            mobileQty,
            showMobileQtyLoader,
        } = this.state;

        const formattedDate = format(selectedDate, `${isSameDay(new Date(), selectedDate) ?  '[Today],' : 'dddd,'} MMM D`)
        const selectedTeeTime = _selctedTeeTime ? preProcessTeeTime(_selctedTeeTime) : _selctedTeeTime
        const isMobile = isWidthDown('xs', this.props.width, true)
        const hotDealCount = hotDeals.length || 'Sold Out';
        const QtySelector =
        <GolferQtyExpantionPanel
            onSelect={this.handleGolferCountChange}
            golferCount={golferCount}
            showAlert={this.props.showSelectGolfersModal}
         />;
        const Calander =
        < DatePicker
            date={selectedDate}
            onChange={this.handleDateChange}
            animateYearScrolling={false}
            className={classes.date}
            disablePast
            showTodayButton
            leftArrowIcon={<ChevronLeft   viewBox="0 0 13 24"  style={{ fontSize: '20px' }} />}
            rightArrowIcon={<ChevronRight   viewBox="0 0 13 24"  style={{ fontSize: '20px' }} />}
        />;
        const Filters =
        <AdvancedFilters
            filters={advFilters}
            onCartChange={this.handleCartSelection}
            onHoleChange={this.handleHoleSelection}
            onTimeChange={this.handleTimeChange}
            onPriceRangeInputChange={this.handlePriceRangeInputChange}
            onPriceTextInputChange={this.handlePriceTextInputChange}
            onReset={this.handleFilterReset}
            onApplied={this.handleFilterApplied}
            onOpened={this.handleFilterOpened}
        />;


        return (

        <div className={classes.root}>

            {/*  MAIN SECTION START */}
            <Grid container >
                <Grid item xs={12}>
                    <Grid container spacing={ isMobile ? 0 : 40 } justify={'center'} >












                        {/* FILTER SECTION DESKTOP START*/}
                        <Hidden smDown>
                            <Grid item xs={12} sm={12} md={4} lg={4} style={{paddingRight: '10px' }}>
                                    <Grid item xs={12}>
                                        <img
                                            className={classes.logo}
                                            src={Logo}
                                            alt="Powered By Golf Now"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        {QtySelector}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className={classes.datepicker}>

                                            <ExpansionPanel elevation={0} expanded={this.state.showCalander} onChange={this.handleCalanderPanelChange}>
                                                <ExpansionPanelSummary
                                                    expandIcon={<ChevronDown   viewBox="0 0 24 13" className={classes.expand} />}
                                                    IconButtonProps={{ disableRipple: true }}
                                                >
                                                    <CALENDAR  viewBox="0 0 29 29" className={classes.calendar} />
                                                    {/* <img className={classes.calendar} src={CalendarIcon} alt="" /> */}
                                                    <Typography className={classes.dateSelected}>{ formattedDate }</Typography>
                                                </ExpansionPanelSummary>
                                                <ExpansionPanelDetails className={classes.expansion}>
                                                    {Calander}
                                                </ExpansionPanelDetails>
                                            </ExpansionPanel>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {Filters}
                                    </Grid>
                            </Grid>
                        </Hidden>
                        {/* FILTER SECTION DESKTOP END*/}




                        {/* FILTER SECTION MOBILE START */}
                        <Hidden smUp>
                            <Grid item xs={12} sm={12} md={4} lg={4} className={classes.border}>
                                  <Grid container>
                                        <Grid item xs={5}>
                                            <Button  className={classes.mobileTabs} onClick={this.toggleDrawer('QTY', true)}>
                                                <GolfCarate viewBox="0 0 24 33" className={classes.mobileTeeIcon} />
                                                <Typography className={classes.mobileHeader}>
                                                {golferCount === 0 ? `Select Golfers` : `${golferCount} Golfers`}
                                                </Typography>
                                                <ChevronDown   viewBox="0 0 24 13"   className={classes.mobileExpand} />
                                            </Button>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Button  className={`${classes.mobileTabs} ${classes.tabBorder}`} onClick={this.toggleDrawer('CAL', true)} >
                                                <CALENDAR  viewBox="0 0 29 29" className={classes.mobileCalander} />
                                                <Typography className={classes.mobileHeader}>{ formattedDate }</Typography>
                                                <ChevronDown   viewBox="0 0 24 13"  className={classes.mobileExpand}  />
                                            </Button>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Button className={`${classes.mobileTabs} ${classes.tabBorder} ${classes.centerize}`} style={{minWidth: 0}} onClick={this.toggleDrawer('FILTER', true)}>
                                                {/* <img
                                                    src={FilterIcon}
                                                    className={`${classes.filterIcon} ${classes.centerize}`}
                                                    alt=""
                                                /> */}
                                                <Filter viewBox="0 0 18 19" className={`${classes.filterIcon} ${classes.centerize}`} />
                                            </Button>
                                        </Grid>
                                  </Grid>
                            </Grid>
                        </Hidden>
                        {/* FILTER SECTION MOBILE END  */}












                        {/* TEETIMES SECTION START */}
                        <Grid item  xs={12} sm={12} md={8} lg={8} style={{ paddingLeft: isMobile ? null : '10px' }}>


                            {
                                teetimeUnavailibleError ?
                                    <div className={classes.alertTextContainer}>
                                        <Typography className={classes.alertText}>
                                            This Tee Time is no longer available. Please select a new time.
                                        </Typography>
                                    </div> : null
                            }
                            {


                                isFetching ?



                                <Loader loadingText='Fetching Tee Times' />


                                :



                                [

                                <TeeSheet key={0}
                                    title={`Hot Deals (${hotDealCount})`}
                                    handleTeetimeSelection={this.handleTeetimeSelection}
                                    bookingInfoMain="Pay now in full."
                                    bookingInfoSecondary="Prices include green fees and booking fees. Additional fees may be added at checkout."
                                    noTeeTimesMessageMain="No Matching Deals."
                                    noTeeTimesMessageSecondary="Try changing your filters or select from more tee times below."
                                    teetimes={hotDeals}
                                    selectedTeeTime={selectedTeeTime ? selectedTeeTime.id : null}
                                    fetchingReservation={fetchingReservation}
                                />,

                                    <TeeSheet
                                        key={1}
                                        title={`More Tee Times (${teeTimes.length})`}
                                        handleTeetimeSelection={this.handleTeetimeSelection}
                                        bookingInfoMain="Pay booking fees now."
                                        bookingInfoSecondary="Pay green fees at course. Additional fees may be added at checkout."
                                        noTeeTimesMessageMain = "No Matching Times."
                                        noTeeTimesMessageSecondary = "Try changing your filters or select another date."
                                        teetimes={isMobile ? mobileVisibleTimes : visibleTimes}
                                        selectedTeeTime={selectedTeeTime ? selectedTeeTime.id : null }
                                        fetchingReservation={fetchingReservation}
                                    />,

                                    isMobile ?
                                        mobileVisibleTimes.length < teeTimes.length
                                            ? <Fragment key={2}>
                                                <div className={classes.mobileLoadMore} key={0}>
                                                <Button onClick={this.loadMoreTimesMobile}>
                                                 <Typography className={classes.mobileLoadMoreButton} >Load More</Typography>
                                                </Button>
                                                </div>
                                                <Divider key={1}/>
                                                <img
                                                    className={classes.logoMobile}
                                                    src={Logo}
                                                    alt="Powered By Golf Now"
                                                    key={2}
                                                />
                                             </Fragment>
                                            : <Fragment key={2}>
                                                <img
                                                    className={classes.logoMobile}
                                                    src={Logo}
                                                    alt="Powered By Golf Now"
                                                    key={0}
                                                />
                                            </Fragment>
                                        : numberOfPages > 1
                                            ? <Pagination key={2} {...paginationProps} />
                                            : null
                            ]


                        }

                        </Grid>
                         {/* TEETIMES SECTION END */}
















                    </Grid>
                </Grid>
            </Grid>
            {/*  MAIN SECTION END */}














            {/*  CHECKOUT  MODALS START */}

            {/* MOBILE MODAL START */}
            < Hidden smUp >
                { selectedTeeTime && this.props.showSelectGolfersModal ? <Dialog
                    fullScreen
                    open={this.props.showSelectGolfersModal}
                    onClose={this.handleCloseGolferQtyModal}
                    TransitionComponent={Transition}>
                        <div>
                            <Grid container>
                                <Grid item xs={10}></Grid>
                                <Grid item xs={2}>
                                    <CloseIcon
                                        className={classes.closeButtonMobile}
                                        onClick={this.handleCloseGolferQtyModal}
                                    />
                                </Grid>
                            </Grid>
                            <div className={classes.centerize} style={{marginTop: '45%' }}>
                                <GolfCarate viewBox="0 0 24 33"  fill={theme.palette.primary.main} className={classes.modalTeeIcon}/>
                            </div>
                            <div className={classes.centerize} style={{marginTop: '10px' }}>
                                <Typography className={classes.mobileModalBody}>
                                    Please select number of golfers
                                </Typography>
                            </div>
                            <div className={classes.centerize}>
                                <Typography className={classes.mobileModalBody}>
                                    before continuing.
                                </Typography>
                            </div>
                            {
                            showMobileQtyLoader ?
                                <div className={classes.centerize} style={{marginTop: '30px' }}>
                                    <CircularProgress className={classes.progress} size={20} />
                                </div>
                                : null
                            }

                            <div className={classes.centerize}  style={{marginTop: '30px' }}>
                                <QuantitySelector
                                    onSelect={this.handleGolferQtySelectMobile}
                                    qty={mobileQty}
                                    qtyList={selectedTeeTime.golfers.map(count => count)}
                                />
                            </div>

                        </div>

                </Dialog> : null }
            </Hidden>
            {/* MOBILE MODAL END */}

            {/*  CHECKOUT  MODALS END */}













            {/*  MOBILE FILTER DRAWER START*/}
            <Drawer
                anchor="bottom"
                open={this.state.drawer}
                onClose={this.toggleDrawer(null, false)}
                classes={{paperAnchorBottom: classes.drawer}}
                >
                <div>
                    <Grid container className={classes.drawerHeaderContainer} alignItems={'center'} direction={'row'} justify={'center'}>
                        <Grid item xs={2}>
                            <Button className={`${classes.unsetTextTransform}`} onClick={
                                this.state.drawerComponent === 'FILTER'
                                ? this.resetDrawerFilter
                                : this.toggleDrawer(null, false)
                            }>
                                <Typography className={`${classes.drawerActionButtons}`}>
                                    { this.state.drawerComponent === 'FILTER' ? 'Reset'  : 'Close' }
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={8} className={classes.centerize}>
                           <Typography className={classes.drawerTitle}>
                            {
                                    this.state.drawerComponent === 'QTY'
                                    ? 'Select Golfers'
                                    : this.state.drawerComponent === 'CAL'
                                    ? 'Select Date'
                                    : this.state.drawerComponent === 'FILTER'
                                    ? 'Advanced Filters'
                                    : ''
                            }
                           </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            {
                                this.state.drawerComponent === 'FILTER' ?
                                <Button className={`${classes.unsetTextTransform} ${classes.centerize} ${classes.minW100}`} style={{paddingRight: '31px'}} onClick={
                                    this.handleApplyDrawerFilters
                              }>
                                  <Typography className={`${classes.drawerActionButtons}`}>
                                      {this.state.drawerComponent === 'CAL' ? 'Done' : 'Apply'}
                                  </Typography>
                              </Button>

                              : null
                            }
                        </Grid>
                    </Grid>
                    <Divider/>
                    {
                            this.state.drawerComponent === 'QTY'
                            ? <div>
                                <Typography className={`${classes.unsetTextTransform} ${classes.centerize} ${classes.semiBold} ${classes.paddingTop5}`}>
                                    People
                                </Typography>
                                <QuantitySelector onSelect={this.handleGolferCountChangeDrawer} qty={drawerQty} qtyList={[ 1, 2, 3, 4 ]} />
                            </div>
                            : this.state.drawerComponent === 'CAL'
                            ? < DatePicker
                                date={drawerSelectedDate}
                                onChange={this.handleDateChangeDrawer}
                                animateYearScrolling={false}
                                className={classes.date}
                                disablePast
                                showTodayButton
                                leftArrowIcon={<ChevronLeft   viewBox="0 0 13 24"  style={{ fontSize: '20px' }} />}
                                rightArrowIcon={<ChevronRight   viewBox="0 0 13 24"  style={{ fontSize: '20px' }} />}
                                />
                             : <AdvancedFiltersMobile
                                    filters={drawerAdvFilters}
                                    onCartChange={this.handleCartSelectionDrawer}
                                    onHoleChange={this.handleHoleSelectionDrawer}
                                    onTimeChange={this.handleTimeChangeDrawer}
                                    onPriceRangeInputChange={this.handlePriceRangeInputChangeDrawer}
                                />
                    }
                </div>


            </Drawer>
            {/*  MOBILE FILTER DRAWER END*/}



        </div>
        );
    }
}

const mapStateToProps = function(state) {
    return {
        teetimes: state.teetimes,
        selectedDate: state.filters.selectedDate,
        timeRange: state.filters.timeRange,
        priceRange: state.filters.priceRange,
        holeCountSelection: state.filters.holeCountSelection,
        golfCartSelection: state.filters.golfCartSelection,
        golferCount: state.filters.golferCount,
        showSelectGolfersModal: state.selectedTeeTime.showSelectGolfersModal,
        selectedTeeTime: find(time => time.id === state.selectedTeeTime.teetime, state.filters.teetimes),
        fetchingReservation: state.selectedTeeTime.fetchingReservation,
        selectedGolferQty: state.selectedTeeTime.golfers,
        teetimeUnavailibleError: state.selectedTeeTime.teetimeUnavailibleError
  };
};

export default compose(
  withWidth(),
  ReactRedux.connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(TeeTimeSearch);



// WEBPACK FOOTER //
// ./src/containers/TeeTimesSearch/index.js